import type {
  GridProps,
  TextProps} from '@chakra-ui/react'
import {
  Flex,
  forwardRef,
  Grid,
  Text
} from '@chakra-ui/react'

import { WarningIcon } from '../icons/WarningIcon'

export interface CompletedOverviewItemProps extends GridProps {
  label?: string | React.ReactNode
  value?: string | React.ReactNode
  warning?: string | React.ReactNode
  isError?: boolean
}

export const CompletedOverviewValue = forwardRef(
  ({ children, sx, ...rest }: TextProps, ref) => {
    return (
      <Text
        ref={ref}
        sx={{
          fontSize: 'xl',
          fontWeight: 'bold',
          ...sx
        }}
        {...rest}
      >
        {children}
      </Text>
    )
  },
)

export const CompletedOverviewItem = forwardRef(
  function CompletedOverviewItem({ label, value, warning, isError, sx, ...rest }: CompletedOverviewItemProps, ref) {
    return (
      <Grid
        ref={ref}
        sx={{
          w: '100%',
          gap: 2,
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: 'sm',
          borderRadius: 'md',
          bgColor: isError ? 'red.200' : 'none',
          p: 3,
          ...sx,
        }}
        {...rest}

      >
        {typeof label === 'string' && <Text color={isError ? 'red.800' : 'chakra-body-text'}>{label}</Text>}

        {typeof label !== 'string' && label}

        {typeof value === 'string' && (
          <CompletedOverviewValue sx={{ color: isError ? 'red.800' : 'chakra-body-text' }}>{value}</CompletedOverviewValue>
        )}

        {typeof value !== 'string' && value}

        {typeof warning === 'string' && !!warning && (
          <Flex sx={{ alignItems: 'center', gap: 4 }}>
            <WarningIcon />

            <Text sx={{ color: 'red', fontSize: 'sm' }} dangerouslySetInnerHTML={{ __html: warning }}></Text>
          </Flex>
        )}

        {typeof warning !== 'string' && warning}
      </Grid>
    )
  },
)
